import { useTranslation } from "react-i18next";

import ActionButtonLayout from "./ActionButtonLayout";

function MomSysChangeSpareStockButtonLayout ( props ) {

    const { t } = useTranslation();

    return <ActionButtonLayout {...props}>{t("buttonName.changeSpareStock")}</ActionButtonLayout>;

}

export default MomSysChangeSpareStockButtonLayout;

